import { ButtonProps, Button as ChakraButton } from '@chakra-ui/react/button'
import { FC } from 'react'

import { IButtonProps } from './types'

const Button: FC<IButtonProps> = ({
  variant = 'primaryGreen',
  isDisabled,
  children,
  ...props
}) => (
  <ChakraButton
    variant={variant as unknown as ButtonProps['variant']}
    disabled={isDisabled}
    {...props}
  >
    {children}
  </ChakraButton>
)

export default Button
